import { render, staticRenderFns } from "./agv-side-navigation.vue?vue&type=template&id=b1990eea&scoped=true&lang=pug&"
import script from "./agv-side-navigation.vue?vue&type=script&lang=js&"
export * from "./agv-side-navigation.vue?vue&type=script&lang=js&"
import style0 from "./agv-side-navigation.vue?vue&type=style&index=0&id=b1990eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1990eea",
  null
  
)

export default component.exports